export function sortgroups(a, b) {
  var nameA = a.GetGroupName().toLowerCase();
  var nameB = b.GetGroupName().toLowerCase();

  if (nameA == nameB) return 0;
  else if (nameA < nameB) return -1;

  return 1;
}
